import { Category } from 'domains/models/user_resource/category';
import { UserResourceType } from 'domains/models/user_resource/user_resource_type';
import { z } from 'zod';

export const UserResourceTypeEnum = z.nativeEnum(UserResourceType);
export const CategoryEnum = z.nativeEnum(Category);
